import { render, staticRenderFns } from "./OU.vue?vue&type=template&id=7c3e2990&scoped=true"
import script from "./OU.vue?vue&type=script&lang=js"
export * from "./OU.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3e2990",
  null
  
)

export default component.exports